import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Navbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ScrollToTop.jsx");
